<scaffold-dialog [size]="'wide'">
  <div scaffoldDialogBody>
    <div [ngSwitch]="data.type">
      <div *ngSwitchCase="'youtube'">
        <app-youtube-search (selectItem)="setSelected($event)" [data]="data"></app-youtube-search>
      </div>
      <div *ngSwitchCase="'data_search'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
      <div *ngSwitchCase="'data_link'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
      <div *ngSwitchCase="'data_link_label'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
      <div *ngSwitchCase="'data_link_count'">
        <app-data-search (selectItem)="setSelected($event)" [data]="data"></app-data-search>
      </div>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <button pButton severity="secondary" (click)="dialogRef.close()">{{'cancel'|translation}}</button>
    <button *ngIf="(data.type=='data_search' || data.type=='data_link' || data.type=='data_link_count' || data.type=='data_link_label') && !data.prevent_create" pButton severity="primary" (click)="createData(data.search_type,data.context)">{{'create_new'|translation}}</button>
    <button pButton severity="primary" (click)="closeDialog(this.selected)" [disabled]="!this.selected">{{'use_selected'|translation}}</button>
  </div>
</scaffold-dialog>
